require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./grandes-manifestations-epfl-1-12-1.json") })
        }
      }, "path---grandes-manifestations-epfl-1-12-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---grandes-manifestations-epfl-1-12-1!./.cache/json/grandes-manifestations-epfl-1-12-1.json
// module id = 453
// module chunks = 231608221292675